import React, { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    const powerBiUrl = import.meta.env.VITE_POWERBI_REDIRECT_URL;
    if (powerBiUrl) {
      window.location.href = powerBiUrl;
    }
  }, []);

  return (
    <div className="background">
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <div style={{ 
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          animation: 'spin 2s linear infinite'
        }}></div>
        <p style={{ marginTop: '20px', color: '#666' }}>
          Redirecting to Power BI Dashboard...
        </p>
      </div>
    </div>
  );
}

export default App;
